// extracted by mini-css-extract-plugin
export default {"search":"Search_search__QO5Yw","div":"Search_div__fFDaB","searchIcon":"Search_searchIcon__0geNP","deleteIcon":"Search_deleteIcon__UZMW0"};